import {httpCall, httpMethod} from "./http";

export function checkLogin(username: string, password: string) {
	return httpCall( httpMethod.POST, `/login`, {username, password} )
}
